import NotificationProvider from "components/NotificationProvider";
import { questionTypes } from "features/Forms/formBuilder/formBuilderConsts";
import { useUpdateFormResponseMutation } from "features/vehicles/VehicleCustomForm/CustomFormResponseSlice";
import { useEffect, useState } from "react";
import { arrayToObject } from "utils/object-util";
import { EditFormOutputFields } from "./EditFormOutputFields";

export const EditFormOutput = ({
    customFormResponse,
    lotId,
    formType,
    showFailuresOnly,
    setShowFailuresOnly,
    getIsFailure,
    activity
}) => {

    const [updateForm, { isLoading: saving }] = useUpdateFormResponseMutation();

    const [formAnswers, setFormAnswers] = useState({});

    const allQuestions = customFormResponse?.form?.sections?.flatMap(section => section.questions)?.filter(q => q.questionType != questionTypes.Signature);
    const answerLookup = arrayToObject(customFormResponse?.answers?.filter(q => q.questionType != questionTypes.Signature), 'questionId');

    useEffect(() => {
        setFormAnswers(answerLookup)
    }, [customFormResponse?.answers])

    const resetForm = () => {
        setFormAnswers(answerLookup);
    }

    const handleSave = async () => {
        let result = await updateForm({
            ...customFormResponse,
            clientAccountId: customFormResponse?.form?.clientAccountId,
            answers: Object.values(formAnswers),
            lotId: lotId,
            workOrderId: activity?.workOrderId,
            vehicleId: activity?.vehicleId,
            formId: customFormResponse?.form?.id,
            activityId: activity?.id
        });
        if (result?.error) {
            NotificationProvider.error('Failed to update the form');
        } else {
            NotificationProvider.success('Successfully updated the form');
        }
    };

    const isSaving = saving;

    return (
        <>
            <EditFormOutputFields
                customFormResponse={customFormResponse}
                allQuestions={allQuestions}
                formAnswers={formAnswers}
                setFormAnswers={setFormAnswers}
                formType={formType}
                showFailuresOnly={showFailuresOnly}
                setShowFailuresOnly={setShowFailuresOnly}
                getIsFailure={getIsFailure}
                handleSave={handleSave}
                isSaving={isSaving}
                resetForm={resetForm}
            />
        </>
    )
}